export const getStringNotBreakingSpace = (strings: string[], lineBreak = false) =>
  strings.map((str) => str.replaceAll(" ", "\u00A0")).join(lineBreak ? "\n" : " ");
export const trimValue = (value: string | undefined) => (value ? value.trim() : "");

export const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);
